interface NewsItem {
    imageUrl: string;
    text: string;
    date: string;
    linkedinUrl: string;
}
const newsArticles: Array<NewsItem> = [
    {
        imageUrl: 'https://upgetgomedia.s3.eu-west-2.amazonaws.com/london-insulation/lis-news7.jpeg',
        text: 'HAGGERSTON - London, Lag with Ali finish',
        date: 'May 14th, 2021',
        linkedinUrl: 'https://www.linkedin.com/feed/update/urn:li:activity:6798911668534431744',
    },
    {
        imageUrl: 'https://upgetgomedia.s3.eu-west-2.amazonaws.com/london-insulation/lis-news6.jpeg',
        text: 'SCIENCE MUSEUM - London, Phenolic board with PIB finish',
        date: 'May 13th, 2021',
        linkedinUrl: 'https://www.linkedin.com/feed/update/urn:li:activity:6798623387745820672',
    },
    {
        imageUrl: 'https://upgetgomedia.s3.eu-west-2.amazonaws.com/london-insulation/lis-news5.jpeg',
        text: 'SCIENCE MUSEUM - London, Phenolic board with black Pro-clad finish',
        date: 'May 13th, 2021',
        linkedinUrl: 'https://www.linkedin.com/feed/update/urn:li:activity:6798510235507032065',
    },
    {
        imageUrl: 'https://upgetgomedia.s3.eu-west-2.amazonaws.com/london-insulation/lis-news4.jpeg',
        text: 'THE MALL - Luton, Mineral slab with PIB finish',
        date: 'May 12th, 2021',
        linkedinUrl: 'https://www.linkedin.com/feed/update/urn:li:activity:6798229241524695040',
    },
    {
        imageUrl: 'https://upgetgomedia.s3.eu-west-2.amazonaws.com/london-insulation/lis-news3.jpeg',
        text: 'HOXTON HOTEL - London, Custom black mufti finish',
        date: 'May 12th, 2021',
        linkedinUrl: 'https://www.linkedin.com/feed/update/urn:li:activity:6798174517660262400',
    },
    {
        imageUrl: 'https://upgetgomedia.s3.eu-west-2.amazonaws.com/london-insulation/lis-news2.jpeg',
        text: 'HOXTON HOTEL - London, Lag & Ali zinc finish',
        date: 'May 12th, 2021',
        linkedinUrl: 'https://www.linkedin.com/feed/update/urn:li:activity:6798172129452941312',
    },
    {
        imageUrl: 'https://upgetgomedia.s3.eu-west-2.amazonaws.com/london-insulation/news1.jpeg',
        text: 'Website coming soon!',
        date: 'January 18, 2021',
        linkedinUrl:
            'https://www.linkedin.com/posts/london-insulation-services_website-coming-soon-activity-6757038704511987712-2BTk',
    },
];

export { newsArticles };
